const setDebugInfo = () => {
  // TODO: process debug info/breadcrumbs
}

export default setDebugInfo
